import React from 'react';
import { node } from 'prop-types';
import { connect } from 'react-redux';

import { Page } from '../../components/index.js';

const StaticPageComponent = ({ children = null, ...pageProps }) => {
  return <Page {...pageProps}>{children}</Page>;
};



StaticPageComponent.propTypes = {
  children: node,
};

const mapStateToProps = _state => {
  return {};
};

const StaticPage = connect(mapStateToProps)(StaticPageComponent);

export default StaticPage;
